<template>
  <header class="Topbar">

    <div class="DesktopNav">
      <router-link :to="{name: 'Home'}" class="Brand">
        <img src="../assets/images/logo.svg" alt="Logo Captain Vin" width="152" />
      </router-link>

      <template v-if="isLoggedIn">
        <div class="Topbar__search">
          <SearchInput class="Topbar__search-input" v-model="currentSearchInput" @search="searchProducts()" placeholder="Vous recherchez un vin…" />
          <router-link v-if="$route.name !== 'Search'" :to="{name: 'Search', query: {showFilters: true}}" class="Topbar__filters-search-link">
            Recherche avec filtres
          </router-link>
        </div>

        <router-link class="Topbar__link" :to="{name: 'Agent'}">
          <IconBase iconName="captain"><IconCaptain /></IconBase>
          <span class="Topbar__link-text">Mon captain</span>
        </router-link>
        <router-link class="Topbar__link" :to="{name: 'Cart'}">
          <div class="Cart--details">
            <IconBase iconName="cart"><IconCart /></IconBase>
            <span v-if="lineCount > 0" class="Topbar__orders-count">{{ lineCount }}</span>
          </div>
          <span class="Topbar__link-text">Mon panier</span>
        </router-link>

        <a
          class="Topbar__link"
          :class="{'Topbar__link--active': isNavigationVisible}"
          @click="isNavigationVisible = !isNavigationVisible"
        >
          <IconBase v-if="!isNavigationVisible" iconName="menu"><IconMenu /></IconBase>
          <IconBase v-else iconName="close"><IconClose /></IconBase>
          <span class="Topbar__link-text">Menu</span>
        </a>
        <Navigation v-if="isNavigationVisible" @click="isNavigationVisible = !isNavigationVisible" />
      </template>
    </div>

    <div class="MobileNav">
      <div class="MobileNav__left">
        <GoBack v-if="backButton" />
        <a @click="toggleSidebar()" v-else>
          <IconBase iconName="menu"><IconMenu /></IconBase>
        </a>
      </div>
      <div class="MobileNav__center">
        <h1 class="PageTitle">{{ title }}</h1>
      </div>
      <div class="MobileNav__right">
        <template v-if="isLoggedIn">
          <a v-if="$route.name === 'Search'" @click="$emit('showFilters')">
            <IconBase iconName="filter"><IconFilter /></IconBase>
          </a>
          <template v-else>
            <router-link :to="{name: 'Search'}" class="Topbar__search-link">
              <IconBase iconName="Search" width="20" height="20"><IconSearch /></IconBase>
            </router-link>
            <router-link class="Topbar__cart" :to="{name: 'Cart'}">
              <IconBase iconName="cart"><IconCart /></IconBase>
              <span v-if="lineCount > 0" class="Topbar__orders-count Topbar__orders-count--mobile">{{ lineCount }}</span>
            </router-link>
          </template>
        </template>
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters } from "vuex";
import EventBus from "../event-bus";
import SearchInput from "./SearchInput";
import Navigation from "./Navigation";
import GoBack from "./GoBack";
import IconMenu from "./icons/IconMenu";
import IconClose from "./icons/IconClose";
import IconFilter from "./icons/IconFilter";
import IconCart from "./icons/IconCart";
import IconCaptain from "./icons/IconCaptain";
import IconSearch from "./icons/IconSearch";

export default {
  props: {
    title: {
      type: String,
      required: true
    },
    backButton: {
      type: Boolean,
      default: false
    },
    currentSearchInput: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      isNavigationVisible: false
    };
  },
  computed: {
    ...mapGetters("auth", ["isLoggedIn"]),
    ...mapGetters("cart", ["lineCount"])
  },

  methods: {
    toggleSidebar() {
      EventBus.$emit("toggleSidebar");
    },
    searchProducts() {
      this.$router.push({
        name: "Search",
        query: {
          name: this.currentSearchInput
        }
      });
    }
  },
  components: {
    Navigation,
    GoBack,
    IconMenu,
    IconClose,
    IconFilter,
    IconCart,
    IconCaptain,
    IconSearch,
    SearchInput
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/_variables.scss';

.Topbar {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: #fff;

  &__link {
    padding: 0.75*$global-margin $global-margin;
    align-self: stretch;
    display: flex;
    flex-flow: column;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;

    &:hover {
      background-color: $color-smoke;
    }

    &--active,
    &--active:hover {
      background: $color-black;
      color: #fff;
    }

    &-text {
      display: block;
    }
  }

  &__cart {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    position: relative;
  }

  &__search-input {
    margin-bottom: 0;
  }

  &__filters-search-link {
    padding: 0.5rem;
    font-size: 12px;
    color: $color-grey;
    text-decoration: underline;
  }

  &__orders-count {
    display: inline-block;
    border-radius: 50%;
    margin-left: 0.5rem;
    font-size: 0.55em;
    width: 1.75em;
    height: 1.75em;
    line-height: 1.75;
    text-align: center;
    background-color: $color-black;
    color: #fff;
    position: absolute;
    top: -3px;
    right: -3px;

    &--mobile {
      font-size: 0.4em;
      top: 0;
      right: 0;
    }
  }

  &__search-link {
    height: 20px;
    margin-right: 12px;
  }
}

.Cart--details {
  display: flex;
  position: relative;
}

.DesktopNav {
  position: relative;
  padding: 0.2rem $global-margin;

  @extend .container;// stylelint-disable at-rule-no-unknown

  .Navigation {
    position: absolute;
    z-index: 1;
    margin: 0;
    border-top: 1px solid #fff;
    top: 100%;
    right: $global-margin;
    box-shadow: 0 0 25px rgba(0, 0, 0, 0.25);
  }
}

.MobileNav {
  position: relative;
  padding: 0 $global-margin;
  margin-bottom: $global-margin;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: $color-primary;

  &__left,
  &__right {
    flex: 0 0 20%;
    cursor: pointer;
  }

  &__right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}

@media (max-width: 900px) {
  .DesktopNav {
    display: none;
  }

  .MobileNav {
    display: flex;
  }
}

@media (min-width: 900px) {
  .MobileNav {
    display: none;
  }

  .DesktopNav {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .Topbar {
    position: static;
    margin-bottom: 3*$global-margin;

    &__search {
      flex: 1 0 auto;
      padding: 0 2rem;
    }
  }

  .Brand {
    margin: 0 0 -25px -1*$global-margin;
  }
}

</style>
